import React, { createContext, useContext, useState, useMemo, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const context = createContext();

export const defaultValue = { period: 'day', dealers: [], channel: null, status: null, vin: null };

export default function Provider({ children }) {
  const history = useHistory();

  const [filter, setFilter] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const urlPeriod = params.get('period');
    const urlDealers = params.getAll('dealers');
    const urlChannel = params.get('channel');
    const urlStatus = params.get('status');
    const urlVin = params.get('vin');

    return {
      period: ['day', 'week', 'month'].includes(urlPeriod) ? urlPeriod : defaultValue.period,
      dealers:
        urlDealers.length > 0
          ? urlDealers.map((id) => ({ hmsId: Number(id) }))
          : defaultValue.dealers,
      channel: ['api', 'api_ai', 'mcp'].includes(urlChannel) ? urlChannel : defaultValue.channel,
      status: ['verified', 'not_found'].includes(urlStatus) ? urlStatus : defaultValue.status,
      vin: urlVin || defaultValue.vin
    };
  });

  useEffect(() => {
    const params = new URLSearchParams();
    params.set('period', filter.period);
    if (filter.dealers?.length) {
      filter.dealers.forEach((d) => params.append('dealers', d.hmsId));
    }
    if (filter.channel?.value) params.set('channel', filter.channel?.value);
    if (filter.status?.value) params.set('status', filter.status?.value);
    if (filter.vin) params.set('vin', filter.vin);
    if (filter.period) params.set('period', filter.period?.value || filter.period);

    history.replace({ search: `?${params.toString()}` });
    // eslint-disable-next-line
  }, [filter]);

  const contextValue = useMemo(() => ({ filter, setFilter }), [filter]);

  return <context.Provider value={contextValue}>{children}</context.Provider>;
}

export const useFilter = () => useContext(context).filter;

export const usePatchFilter = () => {
  const { setFilter } = useContext(context);
  return (patch) => setFilter((f) => ({ ...f, ...patch }));
};

export const useResetFilter = () => {
  const { setFilter } = useContext(context);

  return async () => {
    setFilter(defaultValue);
  };
};
